/**
 * Component for customer E-Mail settings page in the Dashboard.
 *
 * @component
 */

import {
  Button,
  message,
  Tabs,
} from 'antd';
import GeneralEmailSettings from './GeneralEmailSettings';
import EmailMessages from './EmailMessages';
import React from 'react';
import { PageButtonHeader } from '../../../../components/CustomHeader';
import { SubscriptionContext } from '../../../../contexts/SubscriptionContext';

const { TabPane } = Tabs;

class Email extends React.Component {
  static contextType = SubscriptionContext;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      activeKey: '1',
    };
  }
  emailMessagesRef = React.createRef();
  generalEmailSettingsRef = React.createRef();

  handleSaveChanges = () => {
    if (this.state.activeKey === '1' && this.generalEmailSettingsRef.current) {
      this.generalEmailSettingsRef.current.handleSubmit();
    } else if (this.state.activeKey === '2' && this.emailMessagesRef.current) {
      this.emailMessagesRef.current.handleSubmit();
    }
  };

  componentDidMount = async () => {
    await this.initializeComponent();
    this.setState({
      loading: false,
    });
  };

  initializeComponent = async () => {
    // Component initialization - child components handle their own data fetching
  };

  render() {
    if (this.state.loading) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <div className="GlobalLoader GlobalLoader--md"></div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <React.Fragment>
          <PageButtonHeader
              headingTitle={'Customer emails'}
              headingRightContent={
                <Button
                  type="primary"
                  onClick={this.handleSaveChanges}
                  style={{ padding: 'var(--input-padding)' }}
                  data-intercom-target="customer-emails-header-save-changes-button-notifications-customer-emails"
                >
                  Save changes
                </Button>
              }
            ></PageButtonHeader>
            <Tabs
              data-intercom-target="email-settings-tabs"
              activeKey={this.state.activeKey}
              onChange={(key) => this.setState({ activeKey: key })}
              defaultActiveKey="1"
              animated={false}
              style={{ minHeight: 500 }}
            >
              <TabPane
                tab={<span>General Settings</span>}
                key="1"
                data-intercom-target="tab-general-settings-email"
              >
                <GeneralEmailSettings ref={this.generalEmailSettingsRef} />
              </TabPane>
              <TabPane
                tab={<span>Email Messages</span>}
                key="2"
                data-intercom-target="tab-email-messages-email"
              >
                <EmailMessages ref={this.emailMessagesRef} />
              </TabPane>
            </Tabs>
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default Email;
